export const inputStyles = {
  base: `
    w-full py-2.5
    text-gray-900 text-sm
    bg-white
    border rounded-lg
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-offset-1
    placeholder:text-gray-400
  `,
  
  default: `
    border-gray-300
    hover:border-gray-400
    focus:border-primary-400
    focus:ring-primary-400/20
  `,
  
  error: `
    border-red-300
    focus:border-red-500
    focus:ring-red-500/20
  `,
  
  focused: `
    shadow-sm
  `,
  
  disabled: `
    bg-gray-50
    text-gray-500
    cursor-not-allowed
    hover:border-gray-300
  `,
};